import React from 'react';
import { ButtonOption } from '@amzn/meridian/button-group';
import { CaseSources } from 'src/utils/jmrUtils';

const AustinOption = ({ disabled }: { disabled: boolean }) => {
  return (
    <ButtonOption
      disabled={disabled}
      value={CaseSources.Austin}
      data-cy="new-jmr__background__caseSource-austin-btnOption"
    >
      {CaseSources.Austin}
    </ButtonOption>
  );
};

export default AustinOption;
